import Clickable from '@web/components/Clickable'
import { gql } from '@web/gql'
import { ReviewGroupExposeStatus } from '@web/gql/graphql'
import links from '@web/libs/constants/links'
import nClicks from '@web/libs/nlog/click/codes'

import styles from '../index.module.scss'

interface Props {
  exposeStatus: ReviewGroupExposeStatus
  nClickArea?: {
    REPORTGUIDE: string
    HIDEGUIDE: string
  }
}

const ReviewStatusNotification = ({ exposeStatus, nClickArea = nClicks.reviewEnd }: Props) => {
  if (exposeStatus === ReviewGroupExposeStatus.ExposeWithNoti) {
    return (
      <div className={styles.hide_notification_area}>
        <div className={styles.txt_area}>
          운영 기준에 따라 숨김 처리된 리뷰입니다.
          <Clickable className={styles.link} href={links.CS_REVIEW_HIDE} nClickCode={nClickArea.HIDEGUIDE}>
            자세히
          </Clickable>
        </div>
      </div>
    )
  }

  return null
}

ReviewStatusNotification.fragments = {
  reviewGroup: gql(`
    fragment ReviewStatusNotification_ReviewGroup on ReviewGroup {
      exposeStatus
    }
    `),
}

export default ReviewStatusNotification
